import React from "react";
import { Link } from "@reach/router";

import "./style.scss";

import heroImg from "../../assets/img/firebird.jpg";

const COMMUNITIES = [
  { name: "Kismet", slug: "kismet" },
  { name: "Saltaire", slug: "saltaire" },
  { name: "Fair Harbor", slug: "fair-harbor" },
  { name: "Atlantique", slug: "atlantique" },
  { name: "Dunewood", slug: "dunewood" },
  { name: "Ocean Beach", slug: "ocean-beach" },
  { name: "Seaview", slug: "seaview" },
  { name: "Ocean Bay Park", slug: "ocean-bay-park" },
];

const HomeHero = () => (
  <section className="home-hero">
    <div
      className="home-hero-photo"
      style={{ backgroundImage: `url(${heroImg})` }}
    />
    <div className="home-hero-fade" />
    <div className="home-hero-content">
      <div className="home-hero-text">
        <h1 className="home-hero-title">
          Bay Shore to Fire Island.
          <br />
          All day, every day, all summer.
        </h1>
        <p className="home-hero-sub">
          Ferry service to western Fire Island communities.
        </p>
        <p className="home-hero-communities">
          {COMMUNITIES.map((c, i) => (
            <React.Fragment key={c.slug}>
              {i > 0 && <span className="home-hero-dot">·</span>}
              <Link className="home-hero-community" to={`/schedules/${c.slug}`}>
                {c.name}
              </Link>
            </React.Fragment>
          ))}
        </p>
        <p className="home-hero-desc">
          A thirty minute ferry from Bay Shore drops you on a barrier island
          with no cars, distinct communities, and miles of uninterrupted
          National Seashore.
        </p>
        <div className="home-hero-ctas">
          <Link to="/schedules" className="btn btn-primary">
            View Schedules →
          </Link>
          {/* <Link to="/explore" className="btn btn-outline-primary">
            Explore the Island
          </Link> */}
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
